import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ExperienceApp } from "./Experience";
import "./styles.css";

if ("serviceWorker" in navigator && window.location.pathname !== "/experience") {
  navigator.serviceWorker.register("/sw.js").catch(() => undefined);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {window.location.pathname === "/experience" ? <ExperienceApp /> : <App />}
  </StrictMode>,
);
